export default __webpack_public_path__ + "static/media/151-trucks.c3697a67.png";